<template>
  <div class="including-courses">
    <div class="courses-header">
      <h2 class="title">
        Add Courses
        <VideoHoverPlayer title="Services We Provide" videoUrl="https://player.vimeo.com/video/1100304206?autoplay=1" />
      </h2>
      <div class="step-badge">Step 4/5</div>
    </div>

    <div class="courses-container">
      <div class="row">
        <!-- Included Courses Section -->
        <div class="col-md">
          <div class="course-section included-courses">
            <h4>Included Courses</h4>
            <ul class="course-list">
              <li
                v-for="(course, index) in includedCourses"
                :key="'included-' + index"
                class="course-item"
              >
                <div class="course-checkbox-wrapper">
                  <input type="checkbox" :id="'included-' + index" checked disabled />
                  <label :for="'included-' + index" class="disabled">
                    {{ course.name }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>

        <!-- Additional Courses Section -->
        <div class="col-md" v-show="plan.plan !== 'scorching'">
          <div class="course-section additional-courses">
            <h4>Additional Courses</h4>
            <div class="search-container">
              <span class="search-icon">
                <img src="@/assets/icons/search-icon.svg" alt="" />
              </span>
              <input
                type="text"
                class="search-input"
                placeholder="Compliance Courses"
                v-model="searchQuery"
              />
            </div>

            <ul class="course-list">
              <!-- Compliance Courses -->
              <li v-if="additionalComplianceCourses.length" class="pb-2 font-weight-bold">
                Compliance Courses
              </li>
              <li
                v-for="(course, index) in additionalComplianceCourses"
                :key="'compliance-' + index"
                class="course-item pb-2"
              >
                <div class="course-checkbox-wrapper">
                  <input
                    type="checkbox"
                    :id="'compliance-' + index"
                    :checked="isCourseSelected(course)"
                    @change="toggleCourse(course, $event)"
                  />
                  <label :for="'compliance-' + index">
                    {{ course.name }}
                  </label>
                </div>
              </li>

              <!-- Additional Other Courses -->
              <li v-if="additionalOtherCourses.length" class="pb-2 font-weight-bold">
                Additional Courses
              </li>
              <li
                v-for="(course, index) in additionalOtherCourses"
                :key="'other-' + index"
                class="course-item pb-2"
              >
                <div class="course-checkbox-wrapper">
                  <input
                    type="checkbox"
                    :id="'other-' + index"
                    :checked="isCourseSelected(course)"
                    @change="toggleCourse(course, $event)"
                  />
                  <label :for="'other-' + index">
                    {{ course.name }}
                  </label>
                </div>
              </li>
            </ul>
          </div>
        </div>
      </div>
    </div>

    <!-- Special Course Modal -->
    <modal :show.sync="showUserModal">
      <h4 slot="header" class="title title-up text-center" style="color: #444c57">
        {{ specialCourseName }}
      </h4>
      <div class="col-md-8 mx-auto">
        <base-input
          label="How many users will be taking this course:"
          type="number"
          min="1"
          :key="specialCourseName"
          v-model="users"
        />
      </div>
      <div class="col-md-6 mx-auto mt-3 text-center">
        <base-button
          size="md"
          class="custom-btn"
          style="background-color: #e66412; color: white; border-color: #e66412"
          @click="confirmSpecialCourse"
        >
          Done
        </base-button>
      </div>
    </modal>
  </div>
</template>

<script>
import VideoHoverPlayer from "@/components/Signup/VideoHoverPlayer.vue";
export default {
  name: "IncludedCourses",
  components: { VideoHoverPlayer },
  props: {
    courses: { type: Array, required: true },
    plan: { required: true },
    tempSelectedCourses: { required: true },
    tempSelectedSpecialCourses: { required: true },
  },
  data() {
    return {
      searchQuery: "",
      selectedCourses: this.tempSelectedCourses ?? [],
      selectedSpecialCourses: this.tempSelectedSpecialCourses ?? [],
      showUserModal: false,
      specialCourseName: "",
      specialCourseId: null,
      users: 1,
    };
  },
  computed: {
    includedCourses() {
      if (this.plan.plan === "scorching") return this.courses;
      return this.courses.filter((course) =>
        this.plan.courses.includes(course.id)
      );
    },
    additionalComplianceCourses() {
      return this.courses.filter(
        (course) =>
          course.course_type === 1 && !this.plan.courses.includes(course.id)
      );
    },
    additionalOtherCourses() {
      return this.courses.filter(
        (course) =>
          course.course_type === 0 && !this.plan.courses.includes(course.id)
      );
    },
  },
  methods: {
    isCourseSelected(course) {
      return (
        this.selectedCourses.some((c) => c.id === course.id) ||
        this.selectedSpecialCourses.some((c) => c.id === course.id)
      );
    },

    toggleCourse(course, event) {
      const checked = event.target.checked;

      if (!checked) {
        this.selectedCourses = this.selectedCourses.filter((c) => c.id !== course.id);
        this.selectedSpecialCourses = this.selectedSpecialCourses.filter((c) => c.id !== course.id);
        this.emitCourses();
        return;
      }

      if (
        course.is_discounted_course === 0 &&
        !this.plan.courses.includes(course.id) &&
        !this.selectedSpecialCourses.find((c) => c.id === course.id)
      ) {
        this.specialCourseName = course.name;
        this.specialCourseId = course.id;
        this.showUserModal = true;
      } else {
        if (!this.selectedCourses.find((c) => c.id === course.id)) {
          this.selectedCourses.push(course);
          this.emitCourses();
        }
      }
    },

    confirmSpecialCourse() {
      const course = this.courses.find((c) => c.id === this.specialCourseId);
      if (!course) return;

      // Avoid duplicates
      const alreadyExists = this.selectedSpecialCourses.some((c) => c.id === course.id);
      if (!alreadyExists) {
        this.selectedSpecialCourses.push({
          id: course.id,
          name: course.name,
          users: parseInt(this.users),
        });
      }

      this.emitCourses();
      this.resetModal();
    },

    emitCourses() {
      this.$emit("courses-selected", {
        selectedCourses: this.selectedCourses,
        selectedSpecialCourses: this.selectedSpecialCourses,
      });
    },

    resetModal() {
      this.showUserModal = false;
      this.specialCourseName = "";
      this.specialCourseId = null;
    },
    initializeSelections() {
      this.selectedCourses = [...this.includedCourses];
      this.selectedSpecialCourses = this.includedCourses
        .filter(course => course.is_discounted_course === 0)
        .map(course => ({
          ...course,
          users: this.plan.controls.users || 0,
        }));

      this.emitCourses();
    },
  },
  created() {
    this.initializeSelections();
  },

  watch: {
    plan: {
      deep: true,
      handler() {
        this.initializeSelections();
      },
    },
  },
};
</script>


<style lang="scss" scoped>
* {
  padding: 0;
  margin: 0;
  box-sizing: border-box;
}
.title {
  font-size: 20px;
  line-height: 25px;
  font-weight: 700;
  margin-bottom: 20px;
  color: #252525;
  display: flex;
  align-items: center;
  .play-icon {
    display: none;
  }
}
.step-badge {
  position: absolute;
  right: 0;
  top: -7px;
  background: #fff0ea;
  padding: 8px 10px;
  border-radius: 6px;
  font-size: 10px;
  line-height: 23px;
  font-weight: 700;
  color: #252525;
}
.including-courses {
  margin-bottom: 30px;
  position: relative;
}

.courses-header {
  margin-bottom: 20px;
}

.courses-header h3 {
  font-weight: 600;
  font-size: 24px;
  display: flex;
  align-items: center;
  color: #333;
}

.video-icon {
  display: inline-flex;
  align-items: center;
  justify-content: center;
  width: 24px;
  height: 24px;
  background-color: #ff5722;
  color: white;
  border-radius: 50%;
  font-size: 12px;
  margin-left: 10px;
}

.courses-container {
  margin-top: 20px;
}

.course-section {
  background-color: #fff;
  border: 1px solid rgba(235, 26, 38, 0.2);
  border-radius: 15px;
  padding: 20px;
  height: 471px;
  overflow: hidden;
  display: flex;
  flex-direction: column;
  h4 {
    font-weight: 800;
    font-size: 20px;
    line-height: 25px;
    margin-bottom: 15px;
    color: #252525;
  }
}

.search-container {
  margin-bottom: 15px;
  position: relative;
  .search-icon {
    position: absolute;
    left: 12px;
    top: 50%;
    transform: translateY(-50%);
    color: #999;
    font-size: 14px;
    img {
      width: 16px;
      height: 16px;
    }
  }
  .search-input {
    width: 100%;
    padding: 14px 15px;
    padding-left: 36px;
    border: 1px solid #e0e0e0;
    border-radius: 12px;
    font-size: 13px;
    line-height: 16px;
    transition: border-color 0.2s;
  }
}

.search-input:focus {
  outline: none;
  border-color: #ff5722;
}

.course-list {
  list-style: none;
  padding: 0;
  margin: 0;
  flex: 1;
  overflow-y: auto;
}

.course-item {
  padding: 10px 0;
}

.course-item:last-child {
  border-bottom: none;
}

.course-checkbox-wrapper {
  display: flex;
  align-items: center;
  position: relative;
  cursor: pointer;
}

.course-checkbox-wrapper input[type="checkbox"] {
  display: none;
}

.course-checkbox-wrapper label {
  margin-bottom: 0;
  cursor: pointer;
  font-size: 14px;
  color: #333;
  position: relative;
  padding-left: 30px;

  &:before {
    content: "";
    position: absolute;
    left: 0;
    top: 50%;
    transform: translateY(-50%);
    width: 16px;
    height: 16px;
    border: 1px solid rgba(37, 37, 37, 0.2);
    border-radius: 2px;
    background-color: white;
  }
}

.course-checkbox-wrapper label.disabled {
  color: #999;
  cursor: default;

  &:before {
    background-color: #f5f5f5;
    border-color: rgba(200, 200, 200, 0.4);
  }
}

.included-badge {
  background: #e6f7ef;
  color: #1f8a5f;
  border-radius: 12px;
  padding: 2px 8px;
  font-size: 12px;
  margin-left: 10px;
}

.course-checkbox-wrapper input[type="checkbox"]:checked + label {
  &:before {
    background-image: url("~@/assets/icons/checked-icon.svg");
    background-position: center;
    background-repeat: no-repeat;
  }
}

.course-checkbox-wrapper input[type="checkbox"]:checked:disabled + label {
  &:before {
    background-image: url("~@/assets/icons/disabled-checked-icon.svg");
  }
}

/* Scrollbar styling */
.course-list::-webkit-scrollbar {
  width: 4px;
}

.course-list::-webkit-scrollbar-track {
  background: rgba(235, 26, 38, 0.1);
  border-radius: 10px;
}

.course-list::-webkit-scrollbar-thumb {
  background: #eb1a26;
  border-radius: 10px;
}

.course-list::-webkit-scrollbar-thumb:hover {
  background: darken(#eb1a26, 10%);
}

@media (max-width: 768px) {
  .col-md-6:first-child {
    margin-bottom: 20px;
  }
}
@media (min-width: 769px) {
  .title {
    font-size: 32px;
    line-height: 40px;
    margin-bottom: 20px;
    .play-icon {
      color: #eb1a26;
      margin-left: 10px;
      font-size: 24px;
      display: block;
    }
  }
  .step-badge {
    top: 0;
    padding: 10px 14px;
    border-radius: 16px;
    font-size: 18px;
  }
  .including-courses {
    margin-top: 60px;
  }
}
</style>
